import { Button, Spinner } from 'components/Elements';
import { Notifications } from 'components/Notifications/Notifications';
import { AuthProvider } from 'lib/auth';
import { queryClient } from 'lib/react-query';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';

const ErrorFallback = () => {
  return (
    <div
      className="w-screen h-screen flex flex-col justify-center items-center bg-gray-50 text-center"
      role="alert"
      aria-labelledby="error-heading"
      aria-describedby="error-description"
    >
      <h2 id="error-heading" className="text-xl font-bold text-red-600">
        Oops! Something went wrong.
      </h2>
      <p id="error-description" className="text-base text-gray-700 mt-2">
        We're sorry for the inconvenience. You can try refreshing the web page or clearing this page
        browser data to fix the issue.
      </p>
      <Button
        className="mt-6 bg-red-500 hover:bg-red-600 text-white"
        onClick={() => {
          localStorage.clear();
          window.location.assign(window.location.origin);
        }}
      >
        Refresh Page
      </Button>
      <p className="text-sm text-gray-500 mt-4">
        Need help? Contact{' '}
        <a href="mailto:ashitacreatives@gmail.com" className="text-red-500 underline">
          ashitacreatives@gmail.com
        </a>
      </p>
    </div>
  );
};

export const AppProvider = ({ children }) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          <Spinner size="xl" />
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
            <Notifications />
            <AuthProvider>
              <Router>{children}</Router>
            </AuthProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
